export default __webpack_public_path__ + "static/nrc-3fb6e2278123079d24e8af7f8a98f520.svg";